module.exports = __webpack_public_path__ + "static/media/ls.32c3a542.svg";